import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index.vue'
import Search from '@/views/search.vue'
import NoSearch from '@/views/goods/nosearch.vue'
import Login from '@/views/login.vue'
import Register from '@/views/register.vue'
import UserInfo from '@/views/user/index.vue'
import GoodsList from '@/views/goods/list.vue'
import GoodsInfo from '@/views/goods/info.vue'
import ResetPassword from '@/views/user/reset.vue'
import FindPassword from '@/views/user/find.vue'
import UserToActivate from '@/views/user/toactivate.vue'
import UserActivate from '@/views/user/activate.vue'
import NotFind from '@/views/404.vue'


import ContacUs from '@/views/user/contacus.vue'
import IndustryInfo from '@/views/industry/index.vue'
import Brand from '@/views/brand/index.vue'
import BrandInfo from '@/views/brand/info.vue'
import BrandList from '@/views/brand/list.vue'
import ClassIndex from '@/views/class/index.vue'

import HelpIndex from '@/views/help/index.vue'
import HelpFqa from '@/views/help/fqa.vue'
import HelpPurchase from '@/views/help/purchase.vue'
import HelpCooperation from '@/views/help/cooperation.vue'
import HelpCooperationGoods from '@/views/help/cooperationgoods.vue'
//html
import Privacy from '@/views/html/privacy.vue'
import Rule from '@/views/html/rule.vue'
import Disclaimers from '@/views/html/disclaimers.vue'

import Header from '@/components/common/HtmlTop.vue'
import Footer from '@/components/common/HtmlFooter.vue'
const includPush = Router.prototype.push
	Router.prototype.push = function push(location) {
  		return includPush.call(this, location).catch(err => err)
	}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      redirect:"/"
    },
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/nosearch',
      name: 'nosearch',
      component: NoSearch
    },
    {
      path:'/search/:searchinfo',
      name:'search',
      component:Search,
      meta:{
        title:'商品搜索',
        content: {
          keywords: '关键词',
          description: '描述'
        }
      }
    },
    {
      path:'/login',
      name:'login',
      component:Login
    },
    {
      path:'/register',
      name:'register',
      component:Register
    },
    {
      path:'/resetpassword/:code',
      name:'resetpassword',
      component:ResetPassword
    },
     {
      path:'/class/index/:id',
      name:'classIndex',
      component:ClassIndex
    },
    {
      path:'/findpassword',
      name:'findpassword',
      component:FindPassword
    },
    {
      path:'/user/index',
      name:'userindex',
      component:UserInfo
    },
    {
      path:'/user/toactivate',
      name:'usertoactivate',
      component:UserToActivate
    },
    {
      path:'/user/activate/:code',
      name:'useractivate',
      component:UserActivate
    },
    {
      path:'/user/contacus',
      name:'contacus',
      component:ContacUs
    },
    
    {
      path:'/goods/list/:pid/:classid/:classname',
      name:'goodslist',
      component:GoodsList
    },
    {
      path:'/goods/info/:goodsid',
      name:'goodsinfo',
      component:GoodsInfo
    },

    /**行业 */
    {
      path:'/industry/index/:id',
      name:'industryinfo',
      component:IndustryInfo
    },
    /**品牌 */
    {
      path:'/brand/index/:id',
      name:'brand',
      component:Brand
    },
    {
      path:'/brand/info/:id',
      name:'brandinfo',
      redirect: {
        name: 'brand',
      }
    },
    {
      path:'/brand/list',
      name:'brandList',
      component:BrandList
    },
    /** 支持 */
    {
      path:'/help/index',
      name:'helpindex',
      component:HelpIndex
    },
    {
      path:'/help/fqa/:sindex?',
      name:'helpfqa',
      component:HelpFqa
    },{
      path:'/help/purchase',
      name:'helppurchase',
      component:HelpPurchase
    },
    {
      path:'/help/cooperation',
      name:'helpcooperation',
      component:HelpCooperation
    }
    ,
    {
      path:'/help/cooperationgoods',
      name:'helpcooperationgoods',
      component:HelpCooperationGoods
    }, 
    {
      path:'/privacy',
      name:'privacy',
      component:Privacy
    }, 
    {
      path:'/html/disclaimers',
      name:'disclaimers',
      component:Disclaimers
    }, 
    {
      path:'/rule',
      name:'rule',
      component:Rule
    },       
    {
      path:'*',
      name:'404',
      component:NotFind
    }        
  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js